export default __webpack_public_path__ + "static/media/approved_enabled.fe379b2c.svg";